export default function ThemeToggler({ themes, themeToggler, activeId }) {
  const btnClasses = [
    "rounded-full",
    "w-28",
    "inline-block",
    "py-3",
    "px-4",
    "border-2",
    "font-mono",
    "font-medium",
    "lowercase",
    "text-sm",
    "hover:opacity-90",
    "transition-all",
    "duration-200",
    "delay-100",
    "ease-in-out",
  ];
  return (
    <div className="flex items-center justify-center gap-2">
      {themes.map((theme) => (
        <button
          className={btnClasses
            .concat([
              theme.textSecondary,
              activeId === theme.id
                ? theme.activeTogglerOutline
                : "border-transparent",
            ])
            .join(" ")}
          style={{ backgroundColor: theme.body }}
          onClick={() => themeToggler(theme.id)}
          key={theme.id}
        >
          {theme.name}
        </button>
      ))}
    </div>
  );
}
